import { render } from "./GroupsIcon.vue?vue&type=template&id=414791c5"
import script from "./GroupsIcon.vue?vue&type=script&lang=js"
export * from "./GroupsIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__